import { Storage } from "@ionic/storage";

class StoreService {
  storage: Storage = new Storage();

  async isReady(): Promise<void> {
    await this.storage.create();
  }
}

const storeService = new StoreService();

export const { storage } = storeService;

export default storeService;
